import React, { useState, useEffect } from 'react';
import '../assets/scss/design.scss';
import { Button, Input, Modal } from 'antd';
import { isAuthenticated } from '../utilities';
import { FeedbackMinImg } from '../utilities/resources';
import { useDispatch } from 'react-redux';
import { INITIATE_AUTH_DRAWER } from '../actions/types';

const { TextArea } = Input;

function AskAnExpert(props) {
  const { visible, setVisible, postAskAnExpert } = props;
  const [questionStr, setQuestionStr] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    setQuestionStr('');
  }, [visible]);

  const handleChange = (value) => {
    setQuestionStr(value);
  };

  const handleSubmit = () => {
    if (isAuthenticated()) {
      if (questionStr && questionStr.trim()) {
        postAskAnExpert(questionStr.trim());
      }
    } else {
      localStorage.setItem('questionStr', questionStr.trim());
      setVisible(false);
      dispatch({
        type: INITIATE_AUTH_DRAWER,
      });
    }
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Modal title='' footer={null} visible={visible} onOk={handleOk} onCancel={handleCancel} width='715px' bodyStyle={{ padding: 0 }}>
      <div className={'feedbackModal'}>
        <div className={'feedbackModalMedia'}>
          <img src={FeedbackMinImg} alt='' />
        </div>
        <div className={'feedbackModalContent askAndExpertContent'}>
          <h1>Post your questions</h1>
          <p>Please enter your question below. Your question will be answered during the webinar</p>
          <TextArea
            onChange={(ev) => handleChange(ev.target.value)}
            type='textarea'
            value={questionStr}
            autoSize={{ minRows: 4, maxRows: 4 }}
            placeholder='Type your question here...'
            allowClear
            size='large'
          />
          <Button disabled={!questionStr || (questionStr && !questionStr.trim())} onClick={handleSubmit} type='primary'>
            SUBMIT
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default AskAnExpert;
